/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Maybe_LaterInputs */

const en_maybe_later = /** @type {(inputs: Maybe_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maybe later`)
};

const es_maybe_later = /** @type {(inputs: Maybe_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tal vez más tarde`)
};

const fr_maybe_later = /** @type {(inputs: Maybe_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peut-être plus tard`)
};

const de_maybe_later = /** @type {(inputs: Maybe_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vielleicht später`)
};

const ja_maybe_later = /** @type {(inputs: Maybe_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`後で`)
};

const zh_maybe_later = /** @type {(inputs: Maybe_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`以后再说`)
};

const ar_maybe_later = /** @type {(inputs: Maybe_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ربما لاحقاً`)
};

const id_maybe_later = /** @type {(inputs: Maybe_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mungkin nanti`)
};

const it_maybe_later = /** @type {(inputs: Maybe_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forse più tardi`)
};

const ru_maybe_later = /** @type {(inputs: Maybe_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Может быть позже`)
};

const pt_maybe_later = /** @type {(inputs: Maybe_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talvez depois`)
};

const ko_maybe_later = /** @type {(inputs: Maybe_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`나중에 하기`)
};

/**
* | output |
* | --- |
* | "Maybe later" |
*
* @param {Maybe_LaterInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const maybe_later = /** @type {((inputs?: Maybe_LaterInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Maybe_LaterInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_maybe_later(inputs)
	if (locale === "es") return es_maybe_later(inputs)
	if (locale === "fr") return fr_maybe_later(inputs)
	if (locale === "de") return de_maybe_later(inputs)
	if (locale === "ja") return ja_maybe_later(inputs)
	if (locale === "zh") return zh_maybe_later(inputs)
	if (locale === "ar") return ar_maybe_later(inputs)
	if (locale === "id") return id_maybe_later(inputs)
	if (locale === "it") return it_maybe_later(inputs)
	if (locale === "ru") return ru_maybe_later(inputs)
	if (locale === "pt") return pt_maybe_later(inputs)
	return ko_maybe_later(inputs)
});